var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.291 3.35352H6.70768C3.83268 3.35352 1.91602 4.79102 1.91602 8.14518V14.8535C1.91602 18.2077 3.83268 19.6452 6.70768 19.6452H16.291C19.166 19.6452 21.0827 18.2077 21.0827 14.8535V8.14518C21.0827 4.79102 19.166 3.35352 16.291 3.35352ZM16.7414 9.18977L13.7418 11.5856C13.1093 12.0935 12.3043 12.3427 11.4993 12.3427C10.6943 12.3427 9.87977 12.0935 9.25685 11.5856L6.25727 9.18977C5.9506 8.9406 5.90268 8.4806 6.14227 8.17393C6.39143 7.86727 6.84185 7.80977 7.14852 8.05893L10.1481 10.4548C10.8764 11.0393 12.1127 11.0393 12.841 10.4548L15.8406 8.05893C16.1473 7.80977 16.6073 7.85768 16.8468 8.17393C17.096 8.4806 17.0481 8.9406 16.7414 9.18977Z",
    fill: "#14141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoMail);
export default __webpack_public_path__ + "static/media/trvto_mail.f00db7dc6fd6ae9f7ea410f1e22596bc.svg";
export { ForwardRef as ReactComponent };